import { render, staticRenderFns } from "./ModeloList.vue?vue&type=template&id=0c5c3606&scoped=true&"
import script from "./ModeloList.vue?vue&type=script&lang=js&"
export * from "./ModeloList.vue?vue&type=script&lang=js&"
import style0 from "./ModeloList.vue?vue&type=style&index=0&id=0c5c3606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5c3606",
  null
  
)

export default component.exports